import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import Row from '../../components/Row'
import Text from '../../components/Text'

const Box = styled.button`
  background: #fff;
  padding: 1.25rem;
  border-radius: 10px;
  border: 1px solid var(--light-gray);
  cursor: pointer;
  text-align: left;
  position: relative;
  transition: all 0.2s;
  top: 0;
  overflow: hidden;
  color: #000;
  width: 100%;
  &:hover {
    top: -5px;
  }
`

const Icon = styled.div`
  font-size: 3rem;
  color: var(--${props => props.color});
  display: flex;
  align-items: center;
  justify-content: center;
`

const Name = styled.div`
  font-weight: 500;
`

const Doctor = styled.div`
  font-size: 0.8rem;
  color: var(--gray);
  padding-top: 0.5rem;
`

const Label = styled.div`
  font-size: 0.8rem;
  color: var(--gray);
  padding-bottom: 0.5rem;
`

class PatientButton extends Component {
  open = () => {
    const { _id, history } = this.props
    history.push(`/edit-patient/${_id}`)
  }

  render() {
    const {
      name,
      gender,
      doctor,
      doctorGender,
      ethnicity,
      diagnosis,
    } = this.props

    return (
      <Box onClick={this.open}>
        <Row>
          <Row.Cell>
            <Icon className="fas fa-user-circle" color={gender === 'MALE' ? 'blue' : 'pink'} />
          </Row.Cell>
          <Row.Cell flex="3">
            <Name>{name}</Name>
            <Doctor>
              <Text value="titles.doctorShorthand" />
              {' '}{doctor}
              {' '}(<Text str={`choices.gender.${doctorGender}`} />)
            </Doctor>
          </Row.Cell>
        </Row>
        <Row>
          <Row.Cell>
            <Label><Text str="titles.gender" /></Label>
            <Text str={`choices.gender.${gender}`} />
          </Row.Cell>
          <Row.Cell flex="2">
            <Label><Text str="titles.ethnicity" /></Label>
            <Text str={`choices.ethnicity.${ethnicity}`} />
          </Row.Cell>
        </Row>
        <Row>
          <Row.Cell>
            <Label><Text str="titles.diagnosis" /></Label>
            <Text str={`choices.diagnosis.${diagnosis}`} />
          </Row.Cell>
        </Row>
      </Box>
    )
  }
}

export default withRouter(PatientButton)



// WEBPACK FOOTER //
// ./src/pages/Demo/PatientButton.js